import React, { Component, PropTypes } from 'react';

export default class TableLayout extends Component {
  constructor(props) {
    super(props);
  }



  render() {

    return (
      <div className="applyToListLP-tableLayoutWrapper">
        <table className="tableLayout">
          <tbody>
            <tr>
              <th className="description"><p>WorldWideWomen Member Fees
  and Benefits</p></th>
              <th>
                <p>Basic</p>
                <p>$120/year</p>
                <p className="small-text">(billed annually)</p>
              </th>
              <th>
                <p>Premium</p>
                <p>$240/year</p>
                <p className="small-text">(billed annually)</p>
              </th>

            </tr>

            <tr>
              <td className="description"><p>Page listing</p></td>
              <td><p><i className="fa fa-check"></i></p></td>
              <td><p><i className="fa fa-check"></i></p></td>
            </tr>
            <tr>
              <td className="description"><p>WorldWideWomen official member badge</p></td>
              <td><p><i className="fa fa-check"></i></p></td>
              <td><p><i className="fa fa-check"></i></p></td>
            </tr>
            <tr>
              <td className="description"><p>Mention on social media channels (FB, Twitter & Instagram to a combined following of 95k+)</p></td>
              <td>
                <p><i className="fa fa-check"></i></p>
                <p>2x/year</p>
              </td>
              <td>
                <p><i className="fa fa-check"></i></p>
                <p>3x/year</p>
              </td>
            </tr>
            <tr>
              <td className="description"><p>Highlight in our email newsletter to 50k+ people globally</p></td>
              <td>
                <p><i className="fa fa-check"></i></p>
                <p>2x/year</p>
              </td>
              <td>
                <p><i className="fa fa-check"></i></p>
                <p>3x/year</p>
              </td>
            </tr>
            <tr>
              <td className="description"><p>Announcement of events and/or special discounts on products or services in email newsletter & social media channels</p></td>
              <td>
                <p><i className="fa fa-check"></i></p>
                <p>2x/year</p>
              </td>
              <td>
                <p><i className="fa fa-check"></i></p>
                <p>4x/year</p>
              </td>
            </tr>
            <tr>
              <td className="description"><p>Featured story/video of your organization on WWW homepage & social media</p></td>
              <td>
                &nbsp;
              </td>
              <td>
                <p><i className="fa fa-check"></i></p>
                <p>2x/year</p>
              </td>
            </tr>
            <tr>
              <td className="description"><p>Ad placement in newsletters</p></td>
              <td>&nbsp;</td>
              <td>
                <p><i className="fa fa-check"></i></p>
                <p>2x/year</p>
              </td>
            </tr>
            <tr>
              <td className="description"><p>Website banner ad on a category landing page</p></td>
              <td>&nbsp;</td>
              <td>
                <p><i className="fa fa-check"></i></p>
                <p>2x/year</p>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

    );
  }
};



// WEBPACK FOOTER //
// ./src/components/applyForBuyFromWomen/TableLayout.jsx